<tabs-inner-wrap>
  <ng-container *ngIf="!isLoading; else loadingTemplate">
    <details-section
      [title]="'simulationBuilder.TESTING_SECTION_TITLE' | transloco"
      [showDetails]="false"
      [description]="readOnly === false ? description : ''"
    >
      <div class="container">
        <div *ngIf="readOnly === false" class="testing-content">
          <div style="max-width: 800px">
            <qai-multiselect
              #multiselect
              [options]="searchOptions"
              [placeholder]="'simulationBuilder.SEARCH_USERS_PLACEHOLDER' | transloco"
              [placement]="'below-start'"
              [offset]="4"
              [startIcon]="'search'"
              (valueChange)="searchValueChange($event)"
              (selectionChange)="searchSelectionChange($event)"
              [value]="defaultSelection"
              [clearButton]="clearOption"
              [selectionDisplayMode]="'single-row-truncated'"
              [visibleOptionsSelectionMode]="visibleOptionsSelectionMode"
              [persistSearch]="true"
            ></qai-multiselect>
          </div>

          <div class="sendAssignments">
            <span #sendBtnWrapper>
              <button
                qai-button
                [shape]="'normal'"
                [kind]="'tertiary'"
                [size]="'medium'"
                [disabled]="readOnly || testersList.length === 0 || networkRequestInProgress || !readyForPublish || isRefinementInProgress"
                (click)="handleSendAssignmentClick($event)"
              >
                {{ 'simulationBuilder.TESTING_SEND_ASSIGNMENTS_BTN' | transloco }}
              </button>
            </span>
            <qai-tooltip
              *ngIf="isRefinementInProgress"
              [qaiFloating]="sendBtnWrapper"
              [placement]="'above-center'"
              [events]="['hover']"
            >
              {{ 'simulationBuilder.REFINEMENT_IN_PROGRESS_TOOLTIP' | transloco }}
            </qai-tooltip>
            <qai-tooltip
              *ngIf="!isRefinementInProgress && (v2HasNoFacts || isMissingMessagingThemes)"
              [qaiFloating]="sendBtnWrapper"
              [placement]="'above-center'"
              [events]="['hover']"
            >
              {{ 'simulationBuilder.TESTING_MESSAGING_TOOLTIP' | transloco }}
            </qai-tooltip>
            <qai-tooltip
              *ngIf="!isRefinementInProgress && !v2HasNoFacts && !isMissingMessagingThemes && hasEmptyFacts"
              [qaiFloating]="sendBtnWrapper"
              [placement]="'above-center'"
              [events]="['hover']"
            >
              {{ 'simulationBuilder.FACTS_CANNOT_BE_EMPTY' | transloco }}
            </qai-tooltip>
            <qai-tooltip
              *ngIf="!isRefinementInProgress && !v2HasNoFacts && !isMissingMessagingThemes && !hasEmptyFacts && isMissingSkillsRubric"
              [qaiFloating]="sendBtnWrapper"
              [placement]="'above-center'"
              [events]="['hover']"
            >
              {{ 'simulationBuilder.SKILLS_RUBRIC_REQUIRED_TOOLTIP' | transloco }}
            </qai-tooltip>
          </div>
        </div>

        <div class="table-wrapper">
          <qai-table
            [headers]="headers"
            [data]="tableData"
            [striped]="false"
            (rowAction)="onTableRowAction($event)"
            [initialSortColumn]="initialSortColumn"
            [initialSortDirection]="initialSortDirection"
            [previousLabel]="'simulationBuilder.PAGINATION_PREVIOUS' | transloco"
            [nextLabel]="'simulationBuilder.PAGINATION_NEXT' | transloco"
          ></qai-table>
        </div>
      </div>
    </details-section>
  </ng-container>

  <ng-template #loadingTemplate>
    <div class="loading-container">
      <qai-loading [size]="'medium'"></qai-loading>
    </div>
  </ng-template>
</tabs-inner-wrap>
